import { createContext, useContext } from 'react';

import { TUserPreference, TUserWithConnect } from '@cloud-wave/neon-common-lib';

export type IFetch = (url, options?) => Promise<Response>;

export type TAuthContext = {
  fetch_: IFetch;
  loaded?: boolean;
  signOut: () => void;
  forgetDevice: () => void;
  connectUserId?: string;
  user: TUserWithConnect | null;
  userPreferences: TUserPreference | null;
  getUser: () => TUserWithConnect | null;
};

const defaultAuth = {
  fetch_: () => Promise.resolve(new Response()),
  signOut: () => {},
  forgetDevice: () => {},
  user: null,
  userPreferences: null,
  getUser: () => null,
};

const context = createContext<TAuthContext>(defaultAuth);

export const useAuthContext = () => useContext(context);

export default context;
